import { useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import PickupStudentStatusDetailMobile from "./pickupStudentStatusDetailMobile";
import PickupStudentStatusDetailWeb from "./pickupStudentStatusDetailWeb";
import { useNavigate } from "react-router-dom";
import { statusBooking } from "../../core/service/api_pickup_student";
const PickupStudentComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("PickupStudent");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const toDetailPage = (id: string) => {
    navigate(`/pickup-student/status/${id}`);
  };

  const cekStatusBooking = async () => {
    try {
      let response = await statusBooking();
      setData(response.data);
    } catch (error) {}
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Pickup Student",
    });
    cekStatusBooking();
  }, []);
  return (
    <>
      <BrowserView>
        <PickupStudentStatusDetailWeb
          toDetailPage={toDetailPage}
          data={data}
          key={JSON.stringify(data)}
        ></PickupStudentStatusDetailWeb>
      </BrowserView>
      <MobileView>
        <PickupStudentStatusDetailMobile
          toDetailPage={toDetailPage}
          data={data}
          key={JSON.stringify(data)}
        ></PickupStudentStatusDetailMobile>
      </MobileView>
    </>
  );
};

export default PickupStudentComponent;
